export const APP_ID = 'APP_ID';
export const GOOGLE_ID = "G-7NQPQVRXW1";
if (process.env.NODE_ENV === 'production') console.log = function () {};
